/**
 * A function that calculate the delay days between two dates, using a conversion of date to milisseconds.
 *
 * @param {string} planned date that the ship will be arriving
 * @param {string} eta date that the ship is actually going to arrive
 * @return {string} 0 days as not delayed when result is positive
 * @return {number} 1 or more days as delayed when result is negative
 */

const MILISSECONDS_PER_DAY = 1000 * 60 * 60 * 24;

export const calculateDelayedDays = (planned?: string, eta?: string) => {
  if (!planned) return;

  if (!eta) return;

  const plannedDate = new Date(planned ?? "");
  const etaDate = new Date(eta ?? "");

  const plannedDateUTC = Date.UTC(
    plannedDate.getFullYear(),
    plannedDate.getMonth(),
    plannedDate.getDate()
  );

  const etaDateUTC = Date.UTC(etaDate.getFullYear(), etaDate.getMonth(), etaDate.getDate());

  const result = Math.floor((etaDateUTC - plannedDateUTC) / MILISSECONDS_PER_DAY);

  if (result <= 0) return 0;

  return Math.abs(result);
};

export const calculateRawDelayedDays = (dateOfArrival: string, predictiveArrival: string): number => {
  const arrivalDate = new Date(dateOfArrival);
  const predictiveDate = new Date(predictiveArrival);

  const diffInMs = arrivalDate.getTime() - predictiveDate.getTime();
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24)); // diferença em dias com sinal
};

export const calculateRawDelayedDaysWithoutTime = (dateOfArrival: string, predictiveArrival: string): number => {
  const arrival = new Date(dateOfArrival);
  const predictive = new Date(predictiveArrival);

  // Extrai apenas o número do dia, mês e ano (sem horas, sem fuso)
  const arrivalUTC = Date.UTC(arrival.getFullYear(), arrival.getMonth(), arrival.getDate());
  const predictiveUTC = Date.UTC(predictive.getFullYear(), predictive.getMonth(), predictive.getDate());

  const diffInMs = arrivalUTC - predictiveUTC;
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
};
